import { BindTourHelpButtons as bindTourHelpButtons, BuilderTourStep, StartBuilderTour, StartTourOptions } from '../product-customizer/tour';

const STORAGE_KEY = 'pin-builder-tour-seen';

const TOUR_STEPS: BuilderTourStep[] = [
    {
        id: 'tour-shape',
        targets: ['#pin-shape-selector'],
        title: 'Pick your shape',
        description: 'Start with the pin shape — circle, square, diamond, or rectangle. Your design carries over when you switch.',
    },
    {
        id: 'tour-size',
        targets: ['#pin-size-selector'],
        title: 'Choose a size',
        description: 'The preview shows the pin at its actual size on your screen. ' +
            'The inch ruler under the preview shows its width, so choose a size with enough room for any words to stay readable.',
    },
    {
        id: 'tour-zoom',
        targets: ['#stage-view-controls'],
        title: 'Work up close',
        description: 'Zoom in to place artwork and text precisely. Zoom out to see the pin at the size you chose.',
    },
    {
        id: 'tour-image-upload',
        // The dropzone hides once the design has layers — fall back to the corner
        // Upload button, then the uploaded-files list label
        targets: ['#pin-upload-zone', '#pin-upload-corner-btn', '.design-uploads-label'],
        title: 'Upload your artwork',
        description: 'Upload your logo or artwork — it prints edge-to-edge across the whole pin. Raster (PNG, JPG) and vector formats (SVG, EPS, AI, PSD, PDF) are all supported.',
    },
    {
        id: 'tour-text-drop',
        targets: [
            '.pin-corner-actions .add-text-drop-btn',
            '.upload-zone-add-text-btn',
            '.add-text-drop-btn',
        ],
        title: 'Add text anywhere',
        description: 'Drop movable text blocks right onto the pin — drag to position, resize and rotate with the handles, and pull the yellow diamond ' +
            'to arc the text. Each block gets its own font, color, and styling from the floating toolbar.',
    },
    {
        id: 'tour-layer-panel',
        targets: ['#pin-design-layer-list'],
        title: 'Manage your layers',
        description: 'Your uploads and text blocks live here — click a row to select it, drag to change the stacking order, and use the eye to hide a layer without deleting it.',
    },
    {
        id: 'tour-background',
        targets: ['#pin-bg-card'],
        title: 'Background color',
        description: 'Give the whole pin a background color, or leave it off to show the polished silver metal.',
    },
    {
        id: 'tour-quantity-price',
        targets: ['#pin-quantity'],
        title: 'Quantity & price',
        description: 'Adjust the quantity to see live pricing — no minimum order required.',
    },
    {
        id: 'tour-add-to-cart',
        targets: ['#pin-add-to-cart'],
        title: 'Add to cart',
        description: 'When you’re happy with your design, add it to your cart to order.',
    },
];

export function StartPinBuilderTour(options: StartTourOptions = {}): void {
    StartBuilderTour({ storageKey: STORAGE_KEY, steps: TOUR_STEPS }, options);
}

/** Wire up any element matching `selector` to re-run the full tour on click. */
export function BindTourHelpButtons(selector: string): void {
    bindTourHelpButtons(selector, () => StartPinBuilderTour({ force: true }));
}
